var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 207,
    viewBox: "0 0 178 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.784 73.9674C161.511 67.2027 157.616 61.1823 151.103 57.4245C148.58 55.9533 145.824 54.9306 142.957 54.4008C141.586 52.5835 139.947 50.9889 138.098 49.6722C138.622 49.0169 139.094 48.3208 139.51 47.5904C141.573 43.9519 142.121 39.6371 141.034 35.5954C139.947 31.5537 137.313 28.116 133.713 26.0387C130.894 24.4074 127.639 23.709 124.404 24.0415C123.369 23.0725 122.227 22.2259 121.002 21.5181C116.722 19.0487 111.643 18.3987 106.882 19.7109C102.122 21.0232 98.0697 24.1903 95.6174 28.5154L95.5575 28.621C89.7495 28.4819 84.0681 30.3672 79.4698 33.9598C79.0855 34.2571 78.5994 34.5891 78.0429 34.9999C74.847 37.2025 71.8457 39.6803 69.0727 42.4054C63.0961 48.2995 57.3521 56.2741 51.53 66.7416C51.4457 66.8902 51.3405 67.0215 51.2523 67.1679L40.1862 85.3534C40.1174 85.4747 40.0487 85.5959 39.9799 85.7171C36.9492 91.0827 35.8968 97.3557 37.0095 103.424C38.1222 109.492 41.3279 114.962 46.0583 118.865L32.0885 143.503C28.7169 149.464 27.8227 156.528 29.602 163.146C31.3814 169.763 35.6891 175.394 41.5799 178.802C44.4976 180.495 47.7195 181.587 51.0596 182.015C54.3996 182.443 57.7915 182.198 61.0393 181.294C64.2905 180.407 67.3361 178.877 69.9999 176.795C72.6637 174.712 74.8927 172.117 76.5579 169.16L90.5277 144.522C96.2613 146.661 102.563 146.678 108.315 144.571C114.067 142.465 118.896 138.37 121.947 133.014L131.97 115.337C132.292 114.874 132.588 114.393 132.854 113.895C134.345 111.061 135.997 108.316 137.802 105.675C144.519 95.8944 150.558 92.0553 152.834 90.6127C153.253 90.3355 153.636 90.1047 154.029 89.8281C156.535 88.0522 158.56 85.6683 159.915 82.8964C161.27 80.1246 161.913 77.0538 161.784 73.9674Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.075 53.6498C102.366 53.3553 107.159 48.642 113.402 51.8804C119.848 55.231 116.743 62.1383 116.743 62.1383C116.743 62.1383 122.258 56.6058 129.282 61.0376C136.091 65.3343 131.685 70.2971 131.427 70.5793C131.771 70.3161 137.42 66.1063 144.103 69.9623C149.958 73.3405 148.148 78.1191 146.117 79.5269C144.429 80.6916 135.698 85.3752 126.455 98.805C124.937 87.8236 115.73 87.3127 103.968 82.0421C92.206 76.7715 94.685 70.1259 88.9834 60.7793C83.3999 51.6048 78.3397 52.9568 78.151 53.0088L78.0206 52.8765C81.8616 49.0823 84.8804 47.2636 87.1218 45.5569C89.758 43.5434 94.707 41.2916 100.07 44.5678C106.141 48.2726 102.321 53.3347 102.075 53.6498Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6929 87.2655L62.2981 75.0618L62.2594 75.0395L55.6064 85.967L51.1954 93.2211C49.5578 96.1117 49.1232 99.5389 49.9873 102.749C50.8514 105.959 52.9433 108.689 55.8031 110.339L59.944 112.728C60.4472 113.018 60.8888 113.405 61.2435 113.867C61.5982 114.33 61.8592 114.858 62.0113 115.423C62.1634 115.987 62.2038 116.577 62.1302 117.157C62.0566 117.738 61.8703 118.298 61.5822 118.807L43.3172 151.02C42.517 152.43 41.9996 153.985 41.7946 155.596C41.5896 157.208 41.7009 158.843 42.1223 160.41C42.5438 161.977 43.267 163.444 44.2506 164.727C45.2342 166.011 46.459 167.086 47.855 167.89C49.2477 168.699 50.7851 169.221 52.3791 169.429C53.9731 169.636 55.5924 169.523 57.1443 169.098C58.6952 168.668 60.1474 167.934 61.4176 166.937C62.6879 165.941 63.7511 164.701 64.5465 163.289L82.8115 131.076C83.0989 130.568 83.4825 130.122 83.9405 129.763C84.3985 129.405 84.9218 129.141 85.4806 128.986C86.0393 128.832 86.6226 128.79 87.197 128.864C87.7713 128.937 88.3256 129.124 88.828 129.414L92.9727 131.805C94.3886 132.623 95.9506 133.151 97.5695 133.358C99.1883 133.566 100.832 133.449 102.408 133.016C103.983 132.582 105.459 131.839 106.75 130.829C108.042 129.82 109.125 128.564 109.936 127.133L120.595 108.333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.595 108.316L84.6383 87.799",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9419 86.1699L113.577 119.423",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5721 161.326C53.7564 162.586 56.5418 161.818 57.7933 159.611C59.0449 157.404 58.2888 154.592 56.1045 153.332C53.9202 152.072 51.1348 152.84 49.8832 155.047C48.6316 157.255 49.3877 160.066 51.5721 161.326Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.389 70.5899C131.733 70.3267 137.382 66.1169 144.065 69.9729C149.92 73.3511 148.11 78.1298 146.079 79.5376C144.391 80.7023 135.66 85.3858 126.417 98.8156C124.314 101.886 122.391 105.078 120.658 108.375L120.581 108.33C109.307 101.826 96.3054 94.4491 84.6219 87.8173L83.6777 87.2725C75.4965 82.625 68.0104 78.3733 62.2829 75.0687C68.5642 63.6101 73.7831 57.0506 78.0068 52.8804C81.8478 49.0863 84.8666 47.2675 87.108 45.5608C89.7443 43.5473 94.6932 41.2955 100.057 44.5717C106.125 48.2804 102.305 53.3425 102.059 53.6576",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.058 53.6691C102.061 53.6621 102.064 53.6555 102.069 53.6495C102.359 53.3551 107.153 48.6417 113.395 51.8801C119.845 55.233 116.74 62.1403 116.74 62.1403C116.74 62.1403 122.255 56.6078 129.28 61.0396C136.088 65.3362 131.682 70.2991 131.425 70.5813",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1464 53.0067C78.3351 52.9546 83.3953 51.6026 88.9788 60.7772C94.6782 70.1276 92.1661 76.7593 103.928 82.0299C115.69 87.3005 124.897 87.8114 126.415 98.7928",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8199 83.0985C82.0328 73.5353 88.7947 64.9194 96.8247 57.6085L76.8199 83.0985Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8199 83.0985C82.0328 73.5353 88.7947 64.9194 96.8247 57.6085",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.774 91.7254C96.9869 82.1623 103.749 73.5463 111.779 66.2354L91.774 91.7254Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.774 91.7254C96.9869 82.1623 103.749 73.5463 111.779 66.2354",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.297 87.4114C89.5098 77.8483 96.2717 69.2323 104.302 61.9215L84.297 87.4114Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.297 87.4114C89.5098 77.8483 96.2717 69.2323 104.302 61.9215",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3434 78.7845C74.5562 69.2214 81.3181 60.6054 89.3481 53.2945L69.3434 78.7845Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3434 78.7845C74.5562 69.2214 81.3181 60.6054 89.3481 53.2945",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.732 100.355C111.943 90.7906 118.703 82.1737 126.733 74.8628L106.732 100.355Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.732 100.355C111.943 90.7906 118.703 82.1737 126.733 74.8628",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2549 96.042C104.465 86.4776 111.226 77.8607 119.256 70.5498L99.2549 96.042Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2549 96.042C104.465 86.4776 111.226 77.8607 119.256 70.5498",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.201 104.664C119.411 95.099 126.173 86.4827 134.205 79.1736L114.201 104.664Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.201 104.664C119.411 95.099 126.173 86.4827 134.205 79.1736",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.696 43.3135C111.222 44.7711 114.444 43.883 115.891 41.3301C117.339 38.7771 116.464 35.5259 113.938 34.0683C111.412 32.6108 108.19 33.4988 106.743 36.0518C105.295 38.6048 106.17 41.8559 108.696 43.3135Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.797 42.3006C125.771 42.8629 127.014 42.5204 127.572 41.5354C128.131 40.5505 127.794 39.2963 126.819 38.734C125.844 38.1717 124.601 38.5142 124.043 39.4991C123.485 40.4841 123.822 41.7383 124.797 42.3006Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.424c8ea2d1d5b833132a8d4d34faa34d.svg";
export { ForwardRef as ReactComponent };